import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const UPDATE_GAM_ORDER_RETARGETING_DEALS_DELIVERY: TypedDocumentNode<
  Data,
  { input: Variables }
> = gql`
  ${ERROR_FRAGMENT}

  mutation UpdateGamOrderRetargetingDealsDelivery(
    $input: ConnectRetargetingDealsDeliveryToGamInput!
  ) {
    connectRetargetingDealsDeliveryToGam(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
